import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import IdpRoutes from './client/routes'
import Cookies from "universal-cookie";
import { API_SECRET_KEY, JWT_COOKIE_NAME } from "../src/client/constants/index";
import axios from "axios";
import { BASE_URL } from "../src/store/slices/urls";

const cookies = new Cookies();
axios.defaults.baseURL = BASE_URL;
axios.defaults.headers.common["x-api-key"] = API_SECRET_KEY;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";
axios.defaults.timeout = 15000;
if (cookies.get(JWT_COOKIE_NAME + "_access")) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${cookies.get(
    JWT_COOKIE_NAME + "_access"
  )}`;
} else {
  axios.defaults.headers.common["Authorization"] = null;
}

function App() {
  return (
    <div className="App">
      <IdpRoutes/>
    </div>
  );
}

export default App;
